import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/DIRECT_DEBIT_ACTIVATION';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (billPayerId?: string, isInternal?: boolean, isAutopayRequired?: boolean, onSuccess?: () => void) => ({
        billPayerId,
        isInternal,
        isAutopayRequired,
        onSuccess,
    }),
);

export const {action: setId} = createAction(`${domain}/SET_ID`, (directDebitInstructionId: string) => ({
    directDebitInstructionId,
}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: setSubmitting} = createAction(`${domain}/SET_SUBMITTING`, submitting => ({submitting}));
